<ng-container *ngIf="this.selectedTab === 0">
    <form [formGroup]="balanceSheetBeforeAfterAppropriationResultsFg">
        <div>
            <snelstart-ui-select-form-control formControlName="value"
                                              class="me-1 custom-input-250"
                                              label="Balans voor of na resultaatbestemming"
                                              [options]="this.optionsVoorNaResultaatbestemming"
                                              (change)="this.onValueChange()">
            </snelstart-ui-select-form-control>
        </div>
    </form>
    <div class="row">
        <div class="col col-1">
        </div>
        <div class="col-2 bold">
            Huidige periode
        </div>
        <div class="col-3 bold">
            Vorige periode
        </div>
    </div>
    <div class="pt-3">
    </div>
    <ng-container *ngIf="this.showCustomControls">
        <form [formGroup]="equityBusinessNaturalPersonsFg">
            <div class="row">
                <div class="col col-1">
                    <p style="padding: 6px">Eigen vermogen onderneming (inclusief fiscale reserves)</p>
                </div>
                <div class="col-2">
                    <ng-container>
                        <snelstart-ui-button type="secondary"
                                             icon="plus"
                                             class="custom-input-150"
                                             (click)="this.showDialog(1)">Specificeer
                        </snelstart-ui-button>
                    </ng-container>
                </div>
                <ng-container>
                    <div class="col-3">
                        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                          class="custom-input-150 custom-readonly"
                                                          align="right"
                                                          prefix="€"
                                                          [showAllDecimals]="false"
                                                          [disabledControl]="true"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                          class="custom-input-150 custom-readonly"
                                                          align="right"
                                                          prefix="€"
                                                          [showAllDecimals]="false"
                                                          [disabledControl]="true"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                </ng-container>
            </div>
        </form>
      <form [formGroup]="equityFg">
        <div class="row">

          <div class="col col-1">
            <p style="padding: 6px"><b>Totaal van eigen vermogen</b></p>
          </div>
          <div class="col-2"></div>
          <ng-container>
            <div class="col-3">
              <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                class="custom-input-150 custom-readonly"
                                                align="right"
                                                prefix="€"
                                                [showAllDecimals]="false"
                                                [disabledControl]="true"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-4">
              <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                class="custom-input-150 custom-readonly"
                                                align="right"
                                                prefix="€"
                                                [showAllDecimals]="false"
                                                [disabledControl]="true"
              >
              </snelstart-ui-number-form-control>
            </div>
          </ng-container>
        </div>
      </form>
    </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
    <form [formGroup]="equityDisclosureFg">
        <div class="row">
            <div class="col col-1 pt-3" style="width: 400px">
                <p style="padding: 6px">Informatieverschaffing over eigen vermogen</p>
            </div>
            <div class="col-2 pt-3">
                <snelstart-ui-button type="secondary"
                                     icon="{{ this.equityDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                                     class="custom-input-150"
                                     (click)="this.showDialog(20)">
                    {{ this.equityDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
                </snelstart-ui-button>
            </div>
        </div>
    </form>
    <form [formGroup]="equityContinuityDisclosureFg">
        <div class="row">
            <div class="col col-1" style="width: 400px">
                <p style="padding: 6px">Informatieverschaffing over de continuïteit met effect op het eigen vermogen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-button type="secondary"
                                     icon="{{ this.equityContinuityDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                                     class="custom-input-150"
                                     (click)="this.showDialog(21)">
                    {{ this.equityContinuityDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
                </snelstart-ui-button>
            </div>
        </div>
    </form>
</ng-container>
<ng-container *ngIf="this.selectedTab === 2">
    <div class="row">
        <div class="col col-1">
            <p style="padding: 6px"><b>Privé opnamen en stortingen natuurlijke personen</b></p>
        </div>
        <div class="col-2"></div>
        <div class="col-3 bold">
            Huidige periode
        </div>
        <div class="col-4 bold">
            Vorige periode
        </div>
    </div>
    <ng-container *ngIf="this.showCustomControls">
        <form [formGroup]="privateIntakesNaturalPersonsFg">
            <div class="row">
              <div class="col col-1">
                <p style="padding: 6px">Totaal privé opnamen</p>
              </div>
              <div class="col-2"></div>
              <div class="col-3">
                <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                  class="custom-input-150 custom-readonly"
                                                  align="right"
                                                  prefix="€"
                                                  [showAllDecimals]="false"
                                                  [disabledControl]="true"
                >
                </snelstart-ui-number-form-control>
              </div>
              <div class="col-4">
                <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                  class="custom-input-150 custom-readonly"
                                                  align="right"
                                                  prefix="€"
                                                  [showAllDecimals]="false"
                                                  [disabledControl]="true"
                >
                </snelstart-ui-number-form-control>
              </div>
            </div>
        </form>
        <form [formGroup]="privateDepositesNaturalPersonsFg">
          <div class="row">
            <div class="col col-1">
              <p style="padding: 6px">Totaal privé stortingen</p>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
              <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                class="custom-input-150 custom-readonly"
                                                align="right"
                                                prefix="€"
                                                [showAllDecimals]="false"
                                                [disabledControl]="true"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-4">
              <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                class="custom-input-150 custom-readonly"
                                                align="right"
                                                prefix="€"
                                                [showAllDecimals]="false"
                                                [disabledControl]="true"
              >
              </snelstart-ui-number-form-control>
            </div>
          </div>
        </form>
    </ng-container>
</ng-container>
<div *ngIf="this.index === 1">
    <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                         [(input)]="this.equityBusinessNaturalPersonsFg"
                                                         [title]="'eigen vermogen onderneming natuurlijke personen'"
                                                         (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

<div *ngIf="this.index === 20">
    <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                                 [(input)]="this.equityDisclosureFg"
                                                                 [title]="'Informatieverschaffing over eigen vermogen'"
                                                                 (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 21">
    <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                                 [(input)]="this.equityContinuityDisclosureFg"
                                                                 [title]="'Informatieverschaffing over continuïteit met effect op het eigen vermogen'"
                                                                 (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

<snelstart-ui-dialog-definition id="balansChangeDialog"
                                title="Waarde wijzigen - Balans voor of na resultaatbestemming"
                                size="lg"
                                [(visible)]="openInfoVBalansNaResultaatbestemming">
    <snelstart-ui-dialog-body>
        <div class="ps-1">
            <p>
                Weet je zeker dat je de waarde wilt wijzigen naar
                '<strong>{{ pendingValue === 'NA' ? 'Na resultaatbestemming' : 'Voor resultaatbestemming' }}'</strong>?
            </p>
        </div>

        <div class="ps-1">
            <p class="mb-2">
                <strong>Let op:</strong> het wijzigen van deze waarde heeft grote invloed op de wijze waarop het
                resultaat wordt
                verwerkt binnen het eigen vermogen.
            </p>
            <ul>
                <li>
                    Bij wijzigen naar '<strong>Voor resultaatbestemming</strong>' vindt de verwerking voortaan
                    automatisch plaats en het resultaat uit de winst-en-verliesrekening wordt steeds één-op-één opgenomen als niet te verwijderen regel in de post 'Eigen
                    vermogen onderneming (inclusief fiscale reserves)'. Je bent zelf verantwoordelijk voor het verwijderen van
                    (eventueel) eerder handmatig verwerkt resultaat in een andere regel binnen de post 'Eigen vermogen onderneming (inclusief fiscale reserves)'.
                </li>
                <br/>
                <li>
                    Bij wijzigen naar '<strong>Na resultaatbestemming</strong>' verdwijnt het automatisch verwerkte resultaat uit de post 'Eigen vermogen onderneming (inclusief fiscale reserves)'. Je bent
                    steeds zelf verantwoordelijk voor het op de juiste wijze en volledig opnemen van het resultaat binnen de post 'Eigen vermogen onderneming (inclusief fiscale reserves)'.
                </li>
            </ul>
        </div>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button type="secondary" icon="xmark" btn-x
                             (click)="cancelChange()">Nee, annuleren
        </snelstart-ui-button>

        <snelstart-ui-button class="ps-3" type="primary" icon="check"
                             (click)="confirmChange()">Ja, bevestigen
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

